import controller from './login.controller';

export default {
  controller
};



// WEBPACK FOOTER //
// src/app/login/login.component.ts